import React from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import ChartistGraph from "react-chartist";

import loadContent from "core-module/hoc/loadContent";

import Timeline from "@material-ui/icons/Timeline";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

var Chartist = require("chartist");


const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  cardIconTitle: importedStyle.cardIconTitle,
  stats: importedStyle.stats,
};
                      // {name: 'series-1', data: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]}
                       // [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],


const DataUsageDonut = (props) => {
  const { classes } = props;
  return (
      <Card>
        <CardHeader color="primary" icon>
          <CardIcon color="primary">
            <Timeline />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>WiFi Schedule</h4>
        </CardHeader>
        <CardBody>
          <GridContainer align="center" >
            <GridItem md={4} xs={12}>
          <GridContainer align="center">
            <GridItem xs={12}>
              <br />
              <ChartistGraph
                className="ct-line-wifischedule"
                data={{
                  labels: ['Midnight', '', '', '3am', '', '', '6am', '', '', '9am', '', '', 'Noon', '', '', '3pm', '', '', '6pm', '', '', '9pm', '', ''],
                  series: [
                      {name: 'series-1', data: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]}
                  ],
                }}
                type="Line"
                options={{
                    series: { 'series-1' :{
                        lineSmooth: Chartist.Interpolation.step()
                    }},
                    axisY: {
                        labelInterpolationFnc: function(value) {
                            if (value === 0) {
                                return 'OFF'
                            }
                            if (value === 1) {
                                return 'ON'
                            }
                            return '';
                        }
                    }

                }}
              />
            </GridItem>
            <GridItem xs={12}>
              <br />
              <br />
              <br />
              <h3 className={classes.cardTitle}>
                <small>(Main)</small><br />
               MaisonPerotta
              </h3>
              <h4 className={classes.cardTitle}>
                Always ON
              </h4>
            </GridItem>
          </GridContainer>
            </GridItem>

            <GridItem md={4} xs={12}>
          <GridContainer align="center">
            <GridItem xs={12}>
              <br />
              <ChartistGraph
                className="ct-line-wifischedule"
                data={{
                  labels: ['12am', '', '', '3am', '', '', '6am', '', '', '9am', '', '', 'Noon', '', '', '3pm', '', '', '6pm', '', '', '9pm', '', ''],
                  series: [
                      {name: 'series-1', data: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0]}
                  ],
                }}
                type="Line"
                options={{
                    series: { 'series-1' :{
                        lineSmooth: Chartist.Interpolation.step()
                    }}
                }}
              />
            </GridItem>
            <GridItem xs={12}>
              <br />
              <br />
              <br />
              <h3 className={classes.cardTitle}>
                <small>(Main)</small><br />
               MaisonPerotta
              </h3>
              <h4 className={classes.cardTitle}>
                Schedule ON
              </h4>
              <h3 className={classes.cardTitle}>
                8:00am - Turn ON
              </h3>
              <h3 className={classes.cardTitle}>
                8:00pm - Turn OFF 
              </h3>
            </GridItem>
          </GridContainer>
            </GridItem>
            <GridItem md={4} xs={12}>
          <GridContainer align="center">
            <GridItem xs={12}>
              <br />
            </GridItem>
            <GridItem xs={12}>
              <br />
              <br />
              <br />
              <h3 className={classes.cardTitle}>
                8:00am - Turn ON
              </h3>
              <h3 className={classes.cardTitle}>
                8:00pm - Turn OFF 
              </h3>
            </GridItem>
          </GridContainer>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
  );
};

export default withStyles(styles)(
  loadContent("user.session/broadbandtraffic", DataUsageDonut)
);
